const localeData = require("./locales-data") as {
  DEFAULT_LOCALE: "en"
  SUPPORTED_LOCALES: ["en", "pt", "es", "fr", "de"]
}

export const DEFAULT_LOCALE = localeData.DEFAULT_LOCALE

export const SUPPORTED_LOCALES = localeData.SUPPORTED_LOCALES as readonly [
  "en",
  "pt",
  "es",
  "fr",
  "de",
]

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

export const isSupportedLocale = (value: string | null | undefined): value is SupportedLocale =>
  !!value && SUPPORTED_LOCALES.includes(value as SupportedLocale)

export const getPreferredLocale = (value: string | null | undefined): SupportedLocale =>
  isSupportedLocale(value) ? value : DEFAULT_LOCALE
